export const loadState = (key, defaultValue) => {
  try {
    const serializableState = sessionStorage.getItem(key);
    if (serializableState === null) {
      return defaultValue;
    }
    return JSON.parse(serializableState);
  } catch (error) {
    return defaultValue;
  }
};

export const saveState = (key, obj) => {
  try {
    if (obj === undefined) return;
    const serializableState = JSON.stringify(obj);
    sessionStorage.setItem(key, serializableState);
  } catch (error) {
    console.error("Error saving state to sessionStorage", error);
  }
};
